/*
 * @Description:
 * @version:
 * @Author: 陈朋
 * @Date: 2021-11-17 16:40:31
 * @LastEditTime: 2021-11-19 09:53:11
 */
import { HttpService } from "@/core";
import {
  AccessTypeReq,
  AccessStorageReq,
  AccessTypePageResp,
  AccessStoragePageResp,
  AccessTypeSimpleListResp,
} from "./access-management.interface";
import { Storage } from "./components/addStorage.interface";

export class AccessManagementService {
  //   类型管理
  static useTypePageApi() {
    const api = (params: AccessTypeReq) =>
      HttpService.axios({
        method: "GET",
        url: "/storage_type/page",
        params,
      });
    return HttpService.usePagination<AccessTypePageResp>(api);
  }
  //   数值管理
  static useStoragePageApi() {
    const api = (params: AccessStorageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/storage_type/page/storage",
        params,
      });
    return HttpService.usePagination<AccessStoragePageResp>(api);
  }
  // 新增 数据值
  static useAddStorageApi() {
    const api = (data: Storage) =>
      HttpService.axios({
        method: "POST",
        url: "/storage_type",
        data,
      });
    return HttpService.useRequest<void>(api);
  }
  // 编辑数据值
  static userEditStorage() {
    const api = (data: Storage, id: string) =>
      HttpService.axios({
        method: "PUT",
        url: `/storage_type/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }
  // 删除数据值
  static useDeleteStorageApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/storage_type/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useSimpleListApi() {
    const api = (type: string) =>
      HttpService.axios({
        method: "GET",
        url: `/storage_type/simple/list/${type}`,
      });
    return HttpService.usePagination<AccessTypeSimpleListResp>(api);
  }
}
